/**
 * @author Tanmay <tanmay.pawar@314ecorp.com>
 * @description React Bootstrap component for Application
 */

import React, { useEffect } from 'react';
import log from 'loglevel';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { createRoot } from 'react-dom/client';

import 'styles/common.css';
import 'styles/lexical.css';
import 'styles/tailwind.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import Environment from 'utils/Environment';
import SecureApp from 'components/app/SecureApp';
import { getBasename } from 'utils/url';
import { initializeFaro } from 'utils/initializeFaro';

const container = document.getElementById('root') ?? document.body;
const root = createRoot(container);
const basename = getBasename();
serviceWorkerRegistration.register();
initializeFaro();

const WebRoutes: React.FC = () => {
	useEffect(() => {
		const loglevel = Environment.isIntegration() ? log.levels.TRACE : log.levels.ERROR;
		log.setLevel(loglevel, true);
		if (!new RegExp(basename).exec(window.location.pathname)) {
			window.location.replace(basename);
		}
	}, []);
	return (
		<BrowserRouter basename={basename}>
			<Routes>
				<Route path={'*'} element={<SecureApp />} />
			</Routes>
		</BrowserRouter>
	);
};

root.render(<WebRoutes />);
